import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const CONNECT_NATIVE_TO_GAM: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation connectNativeToGam($input: ConnectNativeToGamInput!) {
    connectNativeToGam(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
